/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     静态路由配置选项
  +--------------------------------------------------------------------------------------
*/

import TheLayout from "@/views/layout/TheLayout";

const staticRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/common/Login"),
    meta: { frame: "Common", title: "登录" }
  },
  {
    path: "/pwd",
    name: "Pwd",
    component: () => import("@/views/common/Pwd"),
    meta: { frame: "Common", title: "忘记密码" }
  },
  {
    path: "/refresh",
    name: "Refresh",
    component: () => import("@/views/common/Refresh"),
    meta: { frame: "Common", title: "刷新页面" }
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/common/403"),
    meta: { frame: "Common", title: "403" }
  },
  {
    path: "/me",
    name: "Me",
    component: TheLayout,
    meta: { frame: "Common", title: "个人中心" },
    children: [
      {
        path: "me",
        name: "",
        component: () => import("@/views/common/Me"),
        meta: {
          frame: "Common",
          title: "个人中心",
          layout: 0
        }
      }
    ]
  },
  // {
  //   path: "/msg",
  //   name: "Msg",
  //   component: TheLayout,
  //   meta: { frame: "Common", title: "消息中心" },
  //   children: [
  //     {
  //       path: "msg",
  //       name: "",
  //       component: () => import("@/views/common/Msg"),
  //       meta: {
  //         frame: "Common",
  //         title: "消息中心",
  //         layout: 0
  //       }
  //     }
  //   ]
  // },
  {
    path: "/home",
    name: "Home",
    component: TheLayout,
    meta: { frame: "Common", title: "首页" },
    redirect: "/home/index",
    children: [
      {
        path: "index",
        name: "HomeIndex",
        component: () => import("@/views/common/HomeIndex"),
        meta: {
          frame: "Home",
          title: "首页",
          layout: 0
        }
      },
    ]
  },
  {
    path: "/",
    redirect: "/home/index"
  }
];

export default staticRoutes;
